export default __webpack_public_path__ + "static/teamPhoto2-b7751b36e685b1b1cbb863825be78065.png";